import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { HomeIcon, TasksIcon, FriendsIcon } from './assets/index';

const navPaths = [
  { to: "/", icon: HomeIcon, alt: "Home", text: 'Home' },
  { to: "/tasks", icon: TasksIcon, alt: "Tasks", text: 'Tasks' },
  { to: "/friends", icon: FriendsIcon, alt: "Friends", text: 'Friends' },
]

const BottomNav: React.FC = () => {
  const location = useLocation();

  return (
    <div className="flex  h-full w-full bg-white shadow-[0_-8px_8px_rgb(0,0,0,0.1)] border-t-[3px] border-black rounded-t-xl">
      <nav className="flex justify-around items-center w-full">
        {navPaths.map((el) => <Link to={el.to} className={`flex flex-col items-center ${location.pathname === el.to ? 'text-blue-500' : 'text-gray-600'}`}>
          <div className="w-12 h-12 flex items-center justify-center">
            <img src={el.icon} className="w-full h-full object-contain" alt={el.alt}/>
          </div>
          <span className="text-normal">{el.text}</span>
        </Link>)}
      </nav>
    </div>
  );

};

export default BottomNav;
